import React, { ComponentProps, FC, useMemo } from 'react';

import { Link } from 'react-router-dom';

import { getAccOrigin } from '@adsk/acs-sc-web-platform-api';
import { SideNavigationItem } from '@adsk/alloy-side-navigation';

import { useCurrentRoute } from '../../hooks/useCurrentRoute';
import safeGetPathname from '../../utils/safeGetPathname';
import { checkExcludedPath } from '../ExoSkeletonApi/ExoSkeletonApi';

type LocalSideNavigationItemProps = ComponentProps<
  typeof SideNavigationItem
> & {
  renderHeader?: () => React.JSX.Element;
  renderFooter?: () => React.JSX.Element;
};

const LocalSideNavigationItem: FC<LocalSideNavigationItemProps> = ({
  renderHeader,
  renderFooter,
  ...props
}) => {
  const currentRoute = useCurrentRoute();

  const to = useMemo(() => {
    if (!props?.item?.url) {
      return undefined;
    }

    const pathname = safeGetPathname(props.item.url);

    if (!pathname) {
      return undefined;
    }

    const shouldAddHostname = checkExcludedPath(pathname, currentRoute);

    return shouldAddHostname
      ? new URL(pathname, getAccOrigin()).href
      : pathname;
  }, [props?.item?.url, currentRoute]);

  if (!to) {
    return null;
  }

  return (
    <>
      {renderHeader && renderHeader()}
      <SideNavigationItem
        {...props}
        as={Link}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore this prop is passed to Link component
        to={to}
      />
      {/*Display the footer for the last configuration item, either Configuration Settings or Configuration Members*/}
      {renderFooter && renderFooter()}
    </>
  );
};

LocalSideNavigationItem.propTypes = {
  ...SideNavigationItem.propTypes,
};

export default LocalSideNavigationItem;
